import maplibregl from 'maplibre-gl'
import { Protocol } from 'pmtiles'

const PmTileProtocol = new Protocol()
export const PM_TILES_PROTOCOL = 'pmtiles' as const
export const PM_TILES_PROTOCOL_REGISTERED_KEY =
  '__PmTilesProtocolRegistered__' as const

export function registerPmTilesProtocol() {
  const globalWithProtocolFlag = globalThis as typeof globalThis & {
    [PM_TILES_PROTOCOL_REGISTERED_KEY]?: boolean
  }

  if (!globalWithProtocolFlag[PM_TILES_PROTOCOL_REGISTERED_KEY]) {
    maplibregl.addProtocol(PM_TILES_PROTOCOL, PmTileProtocol.tile)
    globalWithProtocolFlag[PM_TILES_PROTOCOL_REGISTERED_KEY] = true
  }
}
